export default __webpack_public_path__ + "static/media/apilador.b5917104.png";